import { TRANSFER_SETTINGS } from '../actionTypes';

const initialState = {
  content: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TRANSFER_SETTINGS.SUCCESS:
      return {
        ...state,
        content: action.payload,
      };
    default:
      return state;
  }
};
